import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';

import ConfirmBottomSheet from 'components/ConfirmBottomSheet';
import useStoreTranslation from 'hooks/useStoreTranslation';
import { openURL } from 'utils/webViewUtils';

import { ContactButtonsWrapper, Title, MailIcon, Item, Button, Label, PhoneIcon, WhatsappIcon } from './styles';

const ContactButtons = () => {
  const history = useHistory();
  const { t } = useStoreTranslation();
  const [showWhatsappConfirm, setShowWhatsappConfirm] = useState(false);

  const handlePhoneButtonClick = () => openURL(`tel:+${t('customerSupport.contact.phoneNumber')}`);
  const handleChatButtonClick = () => setShowWhatsappConfirm(true);
  const handleMailButtonClick = () => history.push('/customerSupport/mail');

  const handleChatCancel = () => setShowWhatsappConfirm(false);
  const handleChatConfirm = () => {
    openURL(`https://wa.me/${t('customerSupport.contact.whatsappNumber')}?text=`);
    setShowWhatsappConfirm(false);
  };

  return (
    <ContactButtonsWrapper>
      <Title>{t('customerSupport.contactButtons.title')}</Title>
      <Item>
        <Button onClick={handleMailButtonClick}>
          <MailIcon />
        </Button>
        <Label>{t('customerSupport.contactButtons.mail')}</Label>
      </Item>
      <Item>
        <Button onClick={handleChatButtonClick}>
          <WhatsappIcon />
        </Button>
        <Label>{t('customerSupport.contactButtons.whatsapp')}</Label>
      </Item>
      <Item>
        <Button onClick={handlePhoneButtonClick}>
          <PhoneIcon />
        </Button>
        <Label>{t('customerSupport.contactButtons.phone')}</Label>
      </Item>

      <ConfirmBottomSheet
        show={showWhatsappConfirm}
        onClose={handleChatCancel}
        onConfirm={handleChatConfirm}
        title={t('customerSupport.contact.whatsappConfirm')}
      />
    </ContactButtonsWrapper>
  );
};

export default ContactButtons;
